import * as MutationTypes from './mutationTypes';

const profileCompletionListSuccess = (state, payload) => {
  state.profileCompletionList = payload;
};

const setSelectedPointOfSaleGuid = (state, selectedPointOfSaleGuid) => {
  state.selectedPointOfSaleGuid = selectedPointOfSaleGuid;
};

const pointOfSaleListSuccess = (state, payload) => {
  state.pointOfSaleList = payload;
};

const modelLanguageListSuccess = (state, payload) => {
  state.modelLanguageList = payload;
};

const setLoading = (state, payload) => {
  state.loading += payload;
};

const optionsSuccess = (state, payload) => {
  state.options = payload;
};

const groupTypeListSuccess = (state, payload) => {
  state.groupList = payload;
};

const moduleStatus = (state, payload) => {
  state.moduleStatus = payload;
};

export const mutations = {
  [MutationTypes.PROFILE_COMPLETION_LIST_SUCCESS]: profileCompletionListSuccess,
  [MutationTypes.SET_LOADING]: setLoading,
  [MutationTypes.SET_SELECTED_POINT_OF_SALE_GUID]: setSelectedPointOfSaleGuid,
  [MutationTypes.POINT_OF_SALE_LIST_SUCCESS]: pointOfSaleListSuccess,
  [MutationTypes.OPTIONS_SUCCESS]: optionsSuccess,
  [MutationTypes.GROUP_TYPE_LIST_SUCCESS]: groupTypeListSuccess,
  [MutationTypes.MODULE_STATUS]: moduleStatus,
  [MutationTypes.MODEL_LANGUAGE_LIST_SUCCESS]: modelLanguageListSuccess,
};
